/* FENN fix: a mouse's side/thumb buttons (reported by the browser as mouse
 * button index 3 = Back and 4 = Forward) are very easy to bump by accident
 * with the base of the thumb while moving the cursor up to the hamburger
 * menu in the top-left corner -- especially right after scrolling, when the
 * hand is already in motion.
 *
 * Confirmed directly on this store's live pages (via
 * performance.getEntriesByType('navigation')[0].notRestoredReasons after a
 * real back-navigation): Shopify serves every storefront page with
 * `Cache-Control: no-store` (reason: "response-cache-control-no-store") --
 * this is set by the Shopify platform itself, to keep cart/session state
 * correct, and is not something a theme can change. That means this store's
 * pages are NEVER eligible for the browser's instant back/forward cache. So
 * an accidental Back press doesn't quietly restore the previous scroll
 * position the way it would on a page that qualifies for bfcache -- it
 * forces a full network reload: the page goes blank and unresponsive for a
 * moment before the homepage reloads from scratch, exactly matching "ele sai
 * do navegador e eu não consigo clicar em nada".
 *
 * v2: capture phase + more event types. The v1 fix only listened on
 * `window` in the (default) bubble phase for `mousedown`/`mouseup`. Two
 * gaps found while re-investigating a fresh report of the same symptom
 * after v1 shipped:
 *   1. Bubble-phase listeners on `window` fire LAST. Any other script on
 *      the page with its own `mousedown`/`mouseup` listener that calls
 *      event.stopPropagation() before bubbling reaches `window` -- a
 *      product-image carousel's drag-to-swipe handler is the most likely
 *      candidate on this store -- silently stops this fix from ever
 *      running for clicks that land on that element, with no error and no
 *      visible symptom other than the bug still happening in that one
 *      area. Listening in the CAPTURE phase ({ capture: true }) runs
 *      this fix FIRST, before any bubble-phase handler gets a chance to
 *      stop propagation, closing that gap.
 *   2. Some browsers/mouse-driver combinations report the side-button
 *      press as an `auxclick` event (fired for any non-primary button)
 *      rather than / in addition to mousedown+mouseup. Blocking that
 *      too is a no-cost safety net.
 *
 * This does NOT cover every possible trigger: some mice ship with vendor
 * driver software (Logitech Options, Razer Synapse, etc.) that lets the
 * owner reassign a side button to send a keyboard shortcut (e.g. Alt+Left)
 * or call the OS/browser's "navigate back" command directly, completely
 * bypassing the web page. No amount of page JavaScript can intercept that
 * -- it never arrives as a mouse event this script can see. If the issue
 * persists after this fix, that driver-level binding is the next thing to
 * rule out (check the mouse's own configuration software, or the Windows
 * "Mouse" settings for that button's assignment).
 *
 * This complements two earlier fixes for other ways an accidental
 * back-navigation could be triggered:
 *   - fenn-disable-sideways-nav-gesture.css: a trackpad swipe or a scroll
 *     wheel's sideways *scroll* being read by the browser as a swipe-based
 *     back gesture.
 *   - fenn-section-anchors.js: our own category-menu links no longer stack
 *     up extra history entries for an accidental back to land on.
 */
(function () {
  function blockSideButtonNav(event) {
    if (event.button === 3 || event.button === 4) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  window.addEventListener('mousedown', blockSideButtonNav, { capture: true });
  window.addEventListener('mouseup', blockSideButtonNav, { capture: true });
  window.addEventListener('auxclick', blockSideButtonNav, { capture: true });
})();
